import {environment} from './environments/environment';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';
import {enableProdMode} from '@angular/core';
import {AppModule} from "./app/app.module";
import { KeycloakService } from 'keycloak-angular';
import {KeycloakInstance} from "keycloak-js";


if (environment.production) {
    enableProdMode();
}


declare const window: any;
const keycloak = window.keycloak;
//console.log(keycloak);

if (keycloak) {
    const keycloakService = new KeycloakService();
    console.log(document.cookie);
    if (document.cookie == "ristorazione=true"){
        keycloak.logout();
        document.cookie = "ristorazione=false;";
    }
    // @ts-ignore
    keycloakService['_instance'] = keycloak as KeycloakInstance;
    platformBrowserDynamic([
        { provide: 'keycloak-service', useValue: keycloakService},
    ]).bootstrapModule(AppModule)
        .catch((error) => console.error('Error bootstrapping the application', error));
} else {
    console.error('Keycloak object not found. Reloading.');
    console.log(window.location.href);
    setTimeout(() => window.location.reload(), 0);
}
